import { type SvgProps, SvgWrapper } from '../utils';
export function TingrettIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M12 16.6154C16.4183 16.6154 20 12.7581 20 8H4C4 12.7581 7.58172 16.6154 12 16.6154Z" />
    </SvgWrapper>
  );
}
